/* global modForm */
import { getCurrentStep, hashStepTracking, showStep, getHeapSessionIdCookieData, initDuplicateSubmissionExperience, getGeolocationData, removeLoader, getIpInfoGeoDetails, trackCROTagToHeap } from '../../../helpers';
import { isCurrentStepSecondToLast } from '../../../validators';
/**
 * Show next step and potential hash step tracking
 * @returns {Boolean} - Returns false if duplicate submission experience is enabled and user is trying to submit the form again
 */
export function showNextStep() {
	const siblingElement = getCurrentStep().nextElementSibling;

	if (siblingElement && (siblingElement.classList.contains('step') || (siblingElement.hasAttribute('data-bind') && siblingElement.getAttribute('data-bind') === 'step'))) {
		const nextStepId = siblingElement.getAttribute('id');

		if (!modForm.opts.ignoreDuplicateSubmissionBlocker && modForm.includeDuplicateSubmissionExperience) {
			const heapSessionIdCookieData = getHeapSessionIdCookieData();
			if (heapSessionIdCookieData.heapSessionSubmitCookie !== null && modForm.getTime < heapSessionIdCookieData.expireInOneHour) {
				initDuplicateSubmissionExperience(heapSessionIdCookieData);
				return false;
			}
		}

		trackCROTagToHeap();

		if (modForm.opts.hashStepTracking) {
			hashStepTracking(nextStepId);
		}

		if (modForm.opts.useAutofill) {
			modForm.opts.steps.forEach(function(step) {
				step.classList.remove('autofill');
			});
		}

		// This is added as a part of WEBP-1379/LP-3270 to send gelocation values as a part of lead to measure the accuracy of Geolookup endpoint
		getGeolocationData(); // This function fetches user's geolocation if not available

		showStep(nextStepId);

		if (siblingElement.hasAttribute('data-step-name') && siblingElement.getAttribute('data-step-name') === 'widget') {
			removeLoader();
		}

		if (isCurrentStepSecondToLast()) {
			getIpInfoGeoDetails();
		}
	}
}
